module.exports = __webpack_public_path__ + "img/Reset_Password_Icon.f63c277a.svg";